<template>
  <div class="history">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">History</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          
          <!-- PC -->
          <v-timeline class="d-none d-sm-block">
            <v-timeline-item small v-for="(year, i) in years" :key="i">
              <div class="py-4">
                <h2 :class="'text-h2 font-weight-light mb-4'">
                  {{year.year}}
                </h2>
                <ul class="list-type01">
                  <li v-for="(item, k) in year.items" :key="k">{{item}}</li>
                </ul>
              </div>
            </v-timeline-item>
          </v-timeline>

          <!-- mobile -->
          <v-timeline dense class="d-sm-none mob">
            <v-timeline-item small v-for="(year, i) in years" :key="i">
              <div class="py-4">
                <h2 :class="'text-h3 font-weight-light mb-4'">
                  {{year.year}}
                </h2>
                <ul class="list-type01">
                  <li v-for="(item, k) in year.items" :key="k">{{item}}</li>
                </ul>
              </div>
            </v-timeline-item>
          </v-timeline>

        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'history',
  data() {
    return {
      years: [
        {
          year: '2023',
          items: [
            '롯데 리테일 사업본부 IoT 플랫폼 구축',
            '롯데손해보험 RPA 전환 구축',
            'LG 화학 RMS 기능개선 및 확산 구축',
            '롯데 리테일 NFT 쇼핑몰 시범사업 구축',
            'BGF 리테일 HR 시스템 구축',
            '삼성전자 N-ERP 자동화플랫폼 운영 및 확산'
          ],
        },
        {
          year: '2022',
          items: [
            'KBank TIBCO 유지보수',
            '삼성전자 Next ERP 자동화플랫폼 운영',
            '하이비젼시스템 RPA 구축',
            'ABL 생명 업무자동화(RPA) 구축',
            '현대백화점카드 차세대 EAI 컨설팅 및 구축',
            '외교부 AI를 활용한 단순.반복 업무 자동화',
            'KT New 재무플랫폼 구축'
          ],
        },
        {
          year: '2021',
          items: [
            '과학기술정보통신부 지능형 AI기반의 하이퍼오토메이션 솔루션 개발',
            '삼성웰스토리 RPA 및 Portal 구축',
            '오이솔루션 RPA 구축',
            '한국능률협회컨설팅 RPA 구축',
            '에스에너지 RPA 구축',
            '한국생산기술연구원 RPA 구축',
            '삼성전자 Next ERP VOC/Demand 시스템 구축',
            'KT 국책카드 전표처리 DX를 통한 업무혁신',
          ],
        },
        {
          year: '2020',
          items: [
            '중소벤처기업부 시장대응형 R&D과제 지능형 RPA 솔루션 개발',
            'KT RPA(AntBot) 구축',
            'KT E2E 글로벌 사업관리 시스템 구축',
            'JBot Portal  솔루션 개발 및 납품',
            '한화토탈 ERP 구축 프로젝트',
          ],
        },
        {
          year: '2019',
          items: [
            '삼성전자 Next ERP 자동화플랫폼 구축',
            '한국남부발전 재무업무(법인카드 사용내역) RPA 구축',
            'KT Skylife ERP 개선 프로젝트',
            'KT 해외 청구 프로세스 개선 프로젝트',
            'KT 재무정보 정확도 향상 프로젝트',
            '삼성전자 기준정보 챗봇 시스템 구축',
          ],
        },
        {
          year: '2018',
          items: [
            'KT Easy ERP ITO 운영',
            'KT 전대리(Chatbot, 법인카드 정산), 무대리(재무 자료 제공), 마비서(출장, 휴가) 구축',
            '삼성전자 RPA/Portal 구축',
            '보스톤사이언티픽 판매/재고 관리 시스템구축',
          ],
        },
        {
          year: '2017',
          items: [
            '삼성전자 에스프린팅 통합 시스템 구축',
            '삼성생명 일류화 EP 컨설팅 및 구축',
            '삼성화재 일류화 EP 컨설팅 및 구축',
            'KT EasyERP ITO 운영',
            'KT EasyERP 기업매출관리 시스템 구축',
          ],
        },
        {
          year: '2016',
          items: [
            '코레일 SAP EP 컨설팅 및 구축',
            'KT Easy ERP 시스템 구축',
            '이스타항공 홈페이지/예약시스템 구축',
          ],
        },
        {
          year: '2015',
          items: [
            '삼성 금융 일류화 EP 컨설팅 및 구축',
            '삼성전자 터키법인 홈 배송 시스템 구축',
            '삼성전자 영국법인 판매 시스템 구축',
            '삼성전자 Sales Portal 운영',
            '삼성전자 GERP ITO 운영',
            '한화토탈 ERP EP 컨설팅 및 구축',
            '삼성화재 LEGACY 개선 프로젝트',
          ],
        },
        {
          year: '2014',
          items: [
            '삼성전자 북미 반품 관리 시스템 구축',
            '삼성전자 동남아 포탈 구축',
            '삼성전자 중국 직영점 시스템 구축',
            '삼성전자 남아공 선적서류관리 구축',
            '삼성코닝 그룹웨어 구축',
            '삼성전자 인도 품의 관리 프로세스 구축',
            '삼성 금융 일류화 EP 컨설팅 및 구축',
          ],
        },
        {
          year: '2012',
          items: [
            '삼성전자 미주 Retail 판매 프로젝트',
            '삼성전자 재무 인력 관리 프로젝트',
            '삼성전자 RISK Management 프로젝트',
            '삼성전자 MyFinance HTML5 전환',
            '삼성전자 Cross-Browsing Phase I',
            '삼성전자 웹 표준화 컨설팅',
          ],
        },
        {
          year: '2011',
          items: [
            '국민연금 웹 개편',
            'MES 제품개발',
            '삼성그룹 일류화 EP 컨설팅',
            '삼성전자 GERP ITO 운영',
            '삼성전자 GERP EP 컨설팅',
            '㈜제인소프트 설립',
          ],
        },
      ],
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".history .sub-body-title", {
      scrollTrigger: {
        trigger: ".history .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".history .sub-body-content", {
      scrollTrigger: {
        trigger: ".sub-body-content",
        toggleActions: "restart none restart none",
      },
      duration: .6, opacity: 0, stagger: .3, delay: .3
    });
    for (var i = 1; i < this.years.length+1; i++) {

      gsap.from(".history .v-timeline-item:nth-child(" + i + ")", {
        scrollTrigger: {
          trigger: ".history .v-timeline-item:nth-child(" + i + ")",
          toggleActions: "restart none none none",
        },
        duration: .6, y: 80, opacity: 0, stagger: .3, delay: .3
      });

    }

    
  },

  methods: {

  }

};
</script>

<style scoped>
</style>